import { defineComponent as _defineComponent } from 'vue'

import { useAuth0 } from '@/composables/useAuth0'
import { Auth0Connection } from '@/utils/Auth0Connection'
import { AuthorizationParams, PopupLoginOptions } from '@auth0/auth0-spa-js'


export default /*#__PURE__*/_defineComponent({
  __name: 'Auth0ConnectionButton',
  props: {
    connection: null
  },
  setup(__props: any) {

const props = __props as {
  connection: Auth0Connection
};



const auth0 = useAuth0()

const goToLogin = async () => {
  const authorizationParams: AuthorizationParams = {
    prompt: 'select_account',
    connection: props.connection.connectionName,
  }
  const options: PopupLoginOptions = {
    authorizationParams,
  }
  await auth0.loginWithPopup(options)
}


return { __sfc: true,props, auth0, goToLogin }
}

})